import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createBooking = async (payload) => {
  const { data } = await axios.post(`${API}/bookings`, payload);
  return data;
};

export const listBookings = async () => {
  const { data } = await axios.get(`${API}/bookings`);
  return data;
};

export const updateBookingStatus = async (id, status) => {
  const { data } = await axios.patch(`${API}/bookings/${id}`, null, {
    params: { status },
  });
  return data;
};

export const deleteBooking = async (id) => {
  const { data } = await axios.delete(`${API}/bookings/${id}`);
  return data;
};

export const getTestimonials = async () => {
  const { data } = await axios.get(`${API}/testimonials`);
  return data;
};
